import { ConsentType, ConsentState } from '@/enums'

export class UserConsent {
  constructor(init: Partial<UserConsent> = {}) {
    this.id = init.id || 0
    this.type = init.type || ConsentType.ClientDataProcessing
    this.title = init.title || ''
    this.stateChangedBy = init.stateChangedBy || ''
    this.state = init.state || ConsentState.NotSet
    this.stateChangedAt = init.stateChangedAt || new Date()
    this.checked = init.state == 'Accepted'
  }
  id: number
  type: ConsentType
  title: string
  state: ConsentState
  stateChangedBy: string
  stateChangedAt: Date
  checked: boolean
}
